module.exports = __webpack_public_path__ + "videos/majesty_mob.a8693f5.mp4";